import get from 'lodash/get'
class InteractiveItemStyle {
  constructor(data) {
    this.style = {
      position: 'absolute',
      cursor: 'pointer',
      top: get(data, 'position.top', 0) + '%',
      left: get(data, 'position.left', 0) + '%',
      width: data.width || 'auto',
      height: data.height || 'auto',
      'line-height': get(data, 'text.lineHeight', 'inherit'),
      'font-family': get(data, 'text.fontFamily', 'inherit'),
      'font-size': get(data, 'text.size', 'inherit'),
      'text-decoration': get(data, 'text.underline') ? 'underline' : 'inherit',
      color: get(data, 'text.color', 'inherit'),
      border: data.border || 'inherit',
      background: data.background || 'inherit'
    };
    var hoverStyle = {
      'line-height': get(data, 'text.lineHeight', 'inherit'),
      'font-family': get(data, 'hover.text.fontFamily', 'inherit'),
      'font-size': get(data, 'hover.text.size', 'inherit'),
      'text-decoration': get(data, 'hover.text.underline') ? 'underline' : 'inherit',
      color: get(data, 'hover.text.color', 'inherit'),
      border: get(data, 'hover.border') || 'none',
      background: get(data, 'hover.background', 'inherit')
    };
    this.hoverStyle = Object.assign({}, this.style, hoverStyle);
  }
}

export { InteractiveItemStyle }
